import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, observable } from 'rxjs';
import { startWith, map, debounceTime, tap, switchMap, filter } from 'rxjs/operators';
import { ClaimService } from '../claim.service';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { TranslateService } from '@ngx-translate/core';
// import { ToastService } from 'src/app/shared/toast/toast.service';
import { AlertService } from 'src/app/shared/toast/alert.service';
import * as  moment from "moment";
export interface State {
  flag: string;
  name: string;
  population: string;
}
declare var myExtObject: any;
@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.css']
})
export class NewComponent implements OnInit {
  title: any = "NewClaim"
  eapReasonEnded: any = [];
  anticpatedOutcome: any = [];
  typeOfService: any = [];
  diagonsesCode: any = [];
  dateOfService: any = [];
  approved: any = [];
  denied: any = [];
  submitted: any = [];
  selectedDates: any
  noteDesclaimer: any
  fullName: any = "N/A"
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @ViewChild('auto') input: any;
  claimForm: FormGroup
  applyValidation: any = false;
  patient = new FormControl();
  isSelected: any = false
  filteredUser: Observable<any[]>;
  authorization: any = [];
  DateOfServices: any;
  ColorCodes: any;
  error: any = ""

  claimId: any;
  isSessionScheduled: number = 2;
  yesRadioButtonCheckd: boolean = false;
  noRadioButtonCheckd: boolean = false;
  userId: any
  claim: any = {}
  constructor(private _ngZone: NgZone,
    private router: Router,
    // private toastService: ToastService,
    private toastService: AlertService,
    private translateService: TranslateService,
    private loadService: CustomLoadingService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private claimService: ClaimService) {

    // alert(1);  
    window["angularComponentRef"] = { component: this, zone: _ngZone };

    console.log("inside constructor");
    //this.chractLeft= 
    this.claimForm = this.formBuilder.group({
      ClaimId: [0],
      PatientId: ['', Validators.compose([Validators.required])],
      DateOfService: ['', Validators.compose([Validators.required])],
      TypeOfService: ['', Validators.compose([Validators.required])],
      PrimaryDiagnoses: [''],
      DateOfNextSession: [''],
      AnticipatedOutcomeOfThisCase: [''],
      ReasonEapserviceEnded: [''],
      Notes: ['', Validators.compose([Validators.required])],
      AuthorizationIds: ['', Validators.compose([Validators.required])],
      IsAnotherSessionScheduled: ['']
    });
    this.activatedRoute.params.subscribe(params => {

      this.userId = params["userId"] || 0
      this.claimForm.controls["PatientId"].setValue(this.userId)
      this.claimId = params["id"] || 0

      if (this.claimId > 0) {
        this.title = "EditClaim"
        this.claimForm.controls["ClaimId"].setValue(this.claimId)
        this.claimForm.controls["ClaimId"].setValidators(Validators.required)
      }
    })


    this.filteredUser = this.patient.valueChanges
      .pipe(
      startWith(''),
      debounceTime(500),
      tap(() => {
        //  this.loadService.show();
      }),
      switchMap(value => {
        if (typeof (this.patient.value) == "object") {
          return []
        }
        return this.claimService.getPatients(this.patient.value, 2).pipe(
          map(results => {
            //  this.loadService.hide();

            if (!this.isSelected) {
              if (results.length <= 0)
                results.push({ "UserId": 0, FullName: this.translateService.instant("Common.PatientNotFound") });
              return results;
            } else {
              this.isSelected = false;
              return [];
            }

          }
          ))
      }
      )
      )


  }

  ngOnInit(): void {

    console.log("inside init");

    this.getClaim();



  }
  displayFn(user: any): string {
    if (user != undefined && user.UserId == 0)
      return
    return user ? user.FullName : user;
  }


  addClaim(model: any, exit: boolean) {

    if (this.claimForm.valid) {
      this.loadService.show();

      this.claimService.addClaim(model).subscribe(res => {
        // this.toastService.activate(this.translateService.instant("NewClaim.Message.Success"))
        this.toastService.success(this.translateService.instant("NewClaim.Message.Success"), { keepAfterRouteChange: true });
        if (exit)
          this.router.navigate(["/claims"]);
        else {
          myExtObject.destroyMultiDatePicker(this.claimForm.controls["DateOfService"].value.replace(/ /g, "").split(","));
          myExtObject.destroyMultiDatePicker1(this.claimForm.controls["DateOfNextSession"].value.replace(/ /g, "").split(","));

          myExtObject.InitializeDatePicker([], [], false, []);
          this.DateOfServices = [];
          this.ColorCodes = [];

          setTimeout(() => {
            myExtObject.InitializeDatePicker1([], [], false, []);
          }, 100);

          this.claimForm.reset();
          this.claimForm.controls["TypeOfService"].setValue("");
          this.claimForm.controls["PrimaryDiagnoses"].setValue("");
          this.claimForm.controls["ReasonEapserviceEnded"].setValue("");
          this.claimForm.controls["DateOfNextSession"].setValue("");
          this.claimForm.controls["AnticipatedOutcomeOfThisCase"].setValue("");
          this.patient.setValue("");
          this.authorization = [];
          this.dateOfService = [];
          this.noteDesclaimer = "";
          this.isSessionScheduled = 2;
          this.noRadioButtonCheckd = false;
          this.yesRadioButtonCheckd = false;

          myExtObject.SetDateOfService();
          myExtObject.SetDateOfService1();
          document.getElementById("char-count").innerText = this.translateMe("Common.CharactersLeft") + ":500";

        }
      }, () => {
        this.loadService.hide();
        // this.error = this.translateService.instant("Common.Exception")
        this.toastService.error(this.translateService.instant("GenericError"), { keepAfterRouteChange: true });
      }, () => {
        this.loadService.hide();
      })

    }
  }
  translateMe(text: any): any {

    return this.translateService.instant(text);
  }
  setDateOfService(date: any) {
    this.claimForm.controls["DateOfService"].setValue(date);
  }
  setDateOfService1(date: any) {

    this.claimForm.controls["DateOfNextSession"].setValue(date);


  }

  applyNoteValidation(dates: any) {

    var model: any = {};
    model.EclaimId = this.claimId;
    model.DateOfServices = dates;
    model.AuthorizationIds = this.claimForm.controls["AuthorizationIds"].value;
    this.loadService.show();
    this.claimService.validateAddClaimNote(model).subscribe((res: any) => {

      this.applyValidation = res.NoteRequired;
      if (res ?.ErrorMessage) {
        this.noteDesclaimer = this.translateService.instant(res.ErrorMessage);
      } else {
        this.noteDesclaimer = ""
      }

      if (res ?.NoteRequired) {

        this.claimForm.controls["Notes"].setValidators(Validators.required);

      }
      else {
        this.applyValidation = false;
        this.claimForm.controls["Notes"].clearValidators();

      }
      this.claimForm.controls["Notes"].updateValueAndValidity();

    }, () => {
      this.loadService.hide();
    }, () => {
      this.loadService.hide();
    });


  }
  onUserSelectionChanged(model: any) {
    this.isSelected = true;
    this.userId = model.option.value.UserId;
    this.fullName = model.option.value.FullName;
    this.getAuthorizations(model.option.value.UserId, model.option.value.FullName);

  }

  getAuthorizations(userId: any, fullName: any) {
    this.claimForm.controls["PatientId"].setValue(userId)

    this.claimService.getPatientAuthorizations(userId, this.claimId).subscribe(res => {
      this.authorization = res.Authorizations;
      this.fullName = fullName;

      this.claim = res.Claim
      if (this.claim) {
        this.claimForm.controls["DateOfService"].setValue(moment(this.claim ?.DateOfService).format("MM/DD/YYYY"));
        this.claimForm.controls["TypeOfService"].setValue(this.claim ?.TypeOfService);
        this.claimForm.controls["PrimaryDiagnoses"].setValue(this.claim ?.PrimaryDiagnoses);
        this.claimForm.controls["ReasonEapserviceEnded"].setValue(this.claim ?.ReasonEapserviceEnded);
        this.claimForm.controls["Notes"].setValue(this.claim ?.Notes);

      }

      var auth = this.authorization.map(a => a.ID
      );

      this.claimForm.controls["AuthorizationIds"].setValue(auth.join(","))


      var dates = [];
      this.authorization.map(d => {
        dates = this.enumerateDaysBetweenDates(moment(d.FromDate), moment(d.ToDate))

      });
      this.dateOfService = res.DateOfServices;


      this.getDateOfService();

      console.log("res.authorization", res.authorization)
      myExtObject.InitializeDatePicker(this.authorization, res.DateOfServices, this.claimId > 0, res.ColorCodes);
      this.DateOfServices = res.DateOfServices;
      this.ColorCodes = res.ColorCodes;
      myExtObject.InitializeDatePicker1(this.authorization, res.DateOfServices, this.claimId > 0, res.ColorCodes);
      myExtObject.SetDateOfService();
      myExtObject.SetDateOfService1();
    });

  }
  getDateOfService() {
    this.approved = this.dateOfService.filter(function (a) {
      return a.Status == 1 && a ?.ShowDate
    }).map(d =>
        moment(d.DateOfService).format('MM/DD/YYYY')

      ).join(", ");


    this.denied = this.dateOfService.filter(function (a) {
      return a.Status == 2 && a ?.ShowDate
    }).map(d => moment(d.DateOfService).format('MM/DD/YYYY')).join(", ");

    this.submitted = this.dateOfService.filter(function (a) {
      return a.Status == 3 && a ?.ShowDate
    }).map(d => moment(d.DateOfService).format('MM/DD/YYYY')).join(", ");

    this.approved = this.approved ? this.approved : "N/A";
    this.denied = this.denied ? this.denied : "N/A";
    this.submitted = this.submitted ? this.submitted : "N/A";
  }

  enumerateDaysBetweenDates(startDate, endDate) {
    var now = startDate.clone(), dates = [];

    while (now.isSameOrBefore(endDate)) {
      dates.push(now.format('M/D/YYYY'));
      now.add(1, 'days');
    }
    return dates;
  };
  getClaim() {
    
    this.loadService.show();
    this.claimService.getClaim(this.claimId, this.userId).subscribe(res => {
      this.eapReasonEnded = res.ReasonForEapRequestEnded;
      this.anticpatedOutcome = res.AnticipatedOutcome;
      this.typeOfService = res.TypeOfService;
      this.diagonsesCode = res.DiagnosesCode

      this.authorization = res.authorization.Authorizations;
      this.fullName = res.authorization.User ?.FullName;
      this.userId = res.authorization.User ?.UserId;
      this.patient.setValue(res.authorization.User)
      this.claim = res.authorization.Claim

      if (this.claim) {

        this.claimForm.controls["DateOfService"].setValue(moment(this.claim ?.DateOfService).format("MM/DD/YYYY"));
        this.claimForm.controls["TypeOfService"].setValue(this.claim ?.TypeOfService);
        this.claimForm.controls["PrimaryDiagnoses"].setValue(this.claim ?.PrimaryDiagnoses);
        this.claimForm.controls["IsAnotherSessionScheduled"].setValue(this.claim ?.IsAnotherSessionScheduled);

        if (this.claim ?.ReasonEapserviceEnded == 0){
          this.claimForm.controls["ReasonEapserviceEnded"].setValue("");
        } else {
          this.claimForm.controls["ReasonEapserviceEnded"].setValue(this.claim ?.ReasonEapserviceEnded);
        }
        this.claimForm.controls["Notes"].setValue(this.claim ?.Notes);

        this.claimForm.controls["DateOfNextSession"].setValue(this.claim ?.DateOfNextSession);

        if (this.claim ?.AnticipatedOutcomeOfThisCase == 0){
          this.claimForm.controls["AnticipatedOutcomeOfThisCase"].setValue("");
        }else{
          this.claimForm.controls["AnticipatedOutcomeOfThisCase"].setValue(this.claim ?.AnticipatedOutcomeOfThisCase);
        }
        
        this.isSessionScheduled = this.claim.IsAnotherSessionScheduled;

        if (this.isSessionScheduled == 1) {
          this.yesRadioButtonCheckd = true;
          this.noRadioButtonCheckd = false;
        } else {
          this.yesRadioButtonCheckd = false;
          this.noRadioButtonCheckd = true;
        }
      }
      var dates = [];
      this.authorization.map(d => {
        dates = this.enumerateDaysBetweenDates(moment(d.FromDate), moment(d.ToDate))

      });
      var auth = this.authorization.map(a =>
        a.ID
      );

      this.claimForm.controls["AuthorizationIds"].setValue(auth.join(","))
      this.dateOfService = res ?.authorization ?.DateOfServices;
      this.getDateOfService();
      myExtObject.InitializeDatePicker(this.authorization, res.authorization.DateOfServices, this.claimId > 0, res.authorization.ColorCodes || [{ "color": "", "text": "what are you doing" }]);

      this.DateOfServices = res.authorization.DateOfServices;
      this.ColorCodes = res.authorization.ColorCodes || [{ "color": "", "text": "what are you doing" }];

      setTimeout(() => {
        myExtObject.InitializeDatePicker1(this.authorization, this.DateOfServices, this.claimId > 0, this.ColorCodes);
      }, 100);

      //myExtObject.InitializeDatePicker1(this.authorization, res.authorization.DateOfServices, this.claimId > 0, res.authorization.ColorCodes || [{ "color": "", "text": "what are you doing" }]);
      myExtObject.SetDateOfService();
      myExtObject.SetDateOfService1();


    }, () => {
      this.loadService.hide();
    }, () => {
      this.loadService.hide();

    })

  }
  onsessionscheduled(radiobuttonValue: any) {

    this.isSessionScheduled = radiobuttonValue;
    if (radiobuttonValue == 1) {
      this.yesRadioButtonCheckd = true;
      this.noRadioButtonCheckd = false;
      this.claimForm.get('DateOfNextSession').setValidators([Validators.required]);
      this.claimForm.get('AnticipatedOutcomeOfThisCase').setValidators([Validators.required]);

      this.claimForm.get('DateOfNextSession').updateValueAndValidity();
      this.claimForm.get('AnticipatedOutcomeOfThisCase').updateValueAndValidity();

      this.claimForm.get('ReasonEapserviceEnded').setValidators(null);
      this.claimForm.get('ReasonEapserviceEnded').updateValueAndValidity();
      if (this.authorization.length > 0) {
        setTimeout(() => {
          myExtObject.InitializeDatePicker1(this.authorization, this.DateOfServices, this.claimId > 0, this.ColorCodes);
        }, 100);
      } else {
        setTimeout(() => {
          myExtObject.InitializeDatePicker1([], [], false, []);
        }, 100);
      }

    } else {
      this.yesRadioButtonCheckd = false;
      this.noRadioButtonCheckd = true;
      this.claimForm.get('DateOfNextSession').setValidators(null);
      this.claimForm.get('AnticipatedOutcomeOfThisCase').setValidators(null);

      this.claimForm.get('DateOfNextSession').updateValueAndValidity();
      this.claimForm.get('AnticipatedOutcomeOfThisCase').updateValueAndValidity();

      this.claimForm.get('ReasonEapserviceEnded').setValidators([Validators.required]);
      this.claimForm.get('AnticipatedOutcomeOfThisCase').updateValueAndValidity();


    }




  }
}